import FormFields from "../../components/common/FormFields";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { FormActions } from "../../components/common/FormActions";
import { URL_DISTRICTS } from "../../utils/urls";
import { DISTRICT } from "../../utils/constants";

export const useDistricts = () => {
  const tableColumns = () => [
    createColumn("name", true, "Name"),
    createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions actions={[createEditAction(URL_DISTRICTS, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_DISTRICTS);

  return { tableData, tableColumns, formRoute };
};

export const useDistrictsForm = () => {
  const fields: any = [
    {
      field_name: "name",
      type: "text",
      label: "District name",
      props: { required: true },
    },
  ];

  const sections: any = [
    {
      title: "District details",
      fields,
    },
  ];

  const redirect = getRegister(URL_DISTRICTS);

  const defaultValues = { location_type: DISTRICT };

  return { fields, sections, redirect, defaultValues };
};

export const DistrictsForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useDistrictsForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
